import { jsx as _jsx } from "react/jsx-runtime";
import { memoGeneric } from '@/js/libs/memo/index.ts';
import { TabsGroupWrapper } from './styled.js';
import { TabsGroupContent } from './TabsGroupContent.js';
export const TabsGroup = memoGeneric(function TabsGroup(props) {
    return (_jsx(TabsGroupWrapper, { children: _jsx(TabsGroupContent, { ...props }) }));
});
